module.exports = __webpack_public_path__ + "img/sharebuttom.a6400b6e.png";